import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { VendorInvoicesPage } from '@/components/VendorInvoices/VendorInvoicesPage'
import { listSearchSchema, withoutListDefaults } from '@/lib/listSearch'
import { inPageSearch } from '@/lib/searchNavigation'

/** Wiring only: the schema and the pruning live in `lib/listSearch`. */
export const Route = createFileRoute('/_app/operations/vendor-invoices/')({
  validateSearch: listSearchSchema,
  component: VendorInvoicesRoute,
})

function VendorInvoicesRoute() {
  const search = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })

  return (
    <VendorInvoicesPage
      search={search}
      // Filtering and paging replace; opening a record pushes, so Back closes
      // it. Either way the page keeps its scroll.
      onSearchChange={(next, options) =>
        void navigate(inPageSearch(withoutListDefaults, next, options))
      }
    />
  )
}
